import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gradient-to-b from-[#0f172a] to-[#1e293b] py-16 md:py-24" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-150">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-151">
            <AlertCircleIcon className="w-8 h-8 text-[#d4a853]" data-id="element-152" />
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center" data-id="element-153">
              El "Efecto Resorte"{' '}
              <span className="text-[#d4a853]" data-id="element-154">No Es Mala Suerte</span>
            </h2>
          </div>

          <div className="space-y-6 text-gray-300 text-lg md:text-xl leading-relaxed" data-id="element-155">
            <p data-id="element-156">
              El famoso "Efecto Resorte" —donde tu bebé se despierta en el
              segundo en que su cuerpo toca el colchón— no es mala suerte.{' '}
              <span className="text-[#f5c542] font-semibold" data-id="element-157">
                Es una alerta biológica de supervivencia activada por el
                cortisol.
              </span>
            </p>

            <p data-id="element-158">
              La mayoría de los consejos que recibes en grupos de Facebook o de
              familiares solo empeoran las cosas. Te dicen que lo canses más,
              que le des cereal o que lo dejes llorar hasta que se rinda.{' '}
              <span className="text-white font-semibold" data-id="element-159">
                Eso solo estresa su sistema nervioso y garantiza despertares
                cada 45 minutos.
              </span>
            </p>

            <p className="text-[#d4a853] font-semibold text-center text-xl md:text-2xl pt-4" data-id="element-160">
              Estás operando en modo supervivencia, y tu cuerpo ya no aguanta
              más.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}